import React from 'react';
import './OrganizerPanel.scss';

export type OrganizerPanelLayoutProps = {
    shouldShowMoreEventsFromThisOrganizer?: boolean;
};

export const OrganizerPanelLayout = ({
    shouldShowMoreEventsFromThisOrganizer,
}: OrganizerPanelLayoutProps) => {
    return (
        <section className="listing-organizer l-section eds-l-pad-bot-5">
            <div
                id="listings-root__organizer-panel"
                className="organizer-panel"
            ></div>
            {shouldShowMoreEventsFromThisOrganizer && (
                <div id="listings-root__more-events-from-this-organizer"></div>
            )}
            <div id="listings-root__collections-related-to-this-event"></div>
        </section>
    );
};
